import React, {Component} from 'react';
import SmartDialog from "../SmartDialog";
import {ReactWizard, WizardPhase} from "../ReactWizard";
import {Field, Form, Formik} from "formik";
import {Button, ButtonGroup, Col, Label, Row} from "reactstrap";
import ImageUploadComponent from "../ImageUploadComponent/ImageUploadComponent";
import FormInput from "../FormInput";
import * as Yup from 'yup';
import Utils, {runStepAsync} from "../../common/Utils";
import AppVariables from "../../common/AppVariables";
import {Gender, TractorState, VerifyStatus} from "../../common/Constants";
import MDSpinner from "react-md-spinner";
import TTLAsyncProxy from "../../common/TTLAsyncProxy";
import {MediaEndpoints, TractorOwnerEndpoints, TractorsEndpoints} from "../../common/ProxyEndpoints";
import TractorUtils from "../../views/Tractors/TractorUtils";
import MDProgress from 'react-md-progress-bar';
import HTML from '../../common/HtmlHelpers';
import PropTypes from 'prop-types';
import fileReaderStream from 'filereader-stream';
import concat from 'concat-stream';
import _ from 'lodash';
import OperatorUtils from "../../views/Operators/OperatorUtils";
import TwoLineItemRender from "../Elements/TwoLineItemRender";
import {LicenseClasses} from "../../views/Operators/OperatorCommon";
import {ExpanderView, SectionedList} from "../AuditExplorer/Elements";
import StandardValue from "../../common/StandardValue";
import MediaHelper from "../../common/MediaHelper";
import AssignmentRulesConfigDialog, {AssignmentRuleInfo} from "../../views/Tractors/AssignmentRulesConfigDialog";

const EmptyOption = { value : '' , label: 'None' };

export class TractorRegistrationForm extends React.Component{

    static propTypes = {
        header: PropTypes.any,
        disableInputs: PropTypes.bool,
        includeOwner: PropTypes.bool,
        operators: PropTypes.array
    };

    constructor(props){
        super(props);
        this.state = {
            isFetchingOperators: false,
            operators: Utils.insertNone([])
        };

        this.proxy = TTLAsyncProxy.getInstance();
    }

    render(){

        const { isValid , operators , includeOwner ,  setFieldValue , values , header , disableInputs } = this.props;
        const proxy = this.proxy;

        return <div>
            <Row>

                <Col md={4}>

                    <ImageUploadComponent name={Utils.formatAvatarName(values.name || "TRACTOR")}
                                          size={84}
                                          disabled={disableInputs}
                                          onChange={file => {
                                              setFieldValue('imageFile',file);
                                          }}/>

                    {values.name && <React.Fragment>
                        <hr/>

                        <div className="text-center">
                            <b>{`${values.name}${values.chassis ? `(${values.chassis}) ${values.registration_number ? ` - ${values.registration_number}` : '' }` : '' }`}</b>
                        </div>
                    </React.Fragment>}

                </Col>

                <Col md={8}>

                    {header}

                    {includeOwner && <React.Fragment>

                        <FormInput name="owner"
                                   title="Tractor Owner"
                                   type="dropdown"
                                   autoFocus={false}
                                   disabled={disableInputs}
                                   async
                                   defaultOptions
                                   onChange={async selected => {

                                       if(selected){

                                           const tractorOwnerId = selected.value;

                                           let operators;
                                           try {
                                               this.setState({ isFetchingOperators : true });
                                               operators =  await TractorUtils.fetchOwnerOperators(tractorOwnerId, true, undefined, undefined);
                                           }
                                           catch (e) {
                                               operators = [];
                                           }
                                           finally {
                                               this.setState({ isFetchingOperators : false });
                                           }


                                           this.setState({
                                               operators: Utils.insertNone(operators.map(o => ({ value: o.id , text: o.name })))
                                           },() => {

                                               if(operators.length > 0){
                                                   const _first = operators[0];
                                                   setFieldValue('operator',{ value: _first.id , label : _first.name });
                                               }
                                               else{
                                                   setFieldValue('operator',EmptyOption);
                                               }

                                           });

                                       }

                                   }}
                                   dropdownItemRender={(props) => {

                                       const { name , media  , user } =  props.data.instance;
                                       return <TwoLineItemRender line1Value={name}
                                                                 line2Prefix={"Phone"}
                                                                 line2Value={user.phone}
                                                                 media={media}/>;
                                   }}
                                   loadOptions={async (value) => {

                                       const response = await proxy.processRequest( TractorOwnerEndpoints.getUrl(),{
                                           fields: [ 'id' , 'name' ],
                                           include: [ 'user' , 'media' ],
                                           search: { keyword: value , method: "inside" , fields: [ "name" , "user.phone" , "user.email" ] },
                                           pagination: {
                                               limit: 5,
                                               offset: 0
                                           },
                                           method: 'get'
                                       });

                                       return response.getPayload().map(v => ({ label: v.name , value: v.id , instance: v }));
                                   }}
                                   icon="fa fa-user"
                                   placeholder="Select tractor owner..."
                                   required/>

                        <hr/>

                    </React.Fragment>}

                    <FormInput name="name"
                               title="Name"
                               type="text"
                               required
                               disabled={disableInputs}
                               placeholder="Enter tractor name"/>

                    <h6>Description</h6>
                    <hr/>

                    <Row>

                        <Col md={8}>

                            <FormInput name="tractor_model"
                                       title="Model"
                                       type="text"
                                       icon="tractor"
                                       required
                                       disabled={disableInputs}
                                       placeholder="Enter tractor model"/>
                        </Col>

                        <Col md={4}>

                            <FormInput name="year"
                                       type="select"
                                       disabled={disableInputs}
                                       items={Utils.GenerateRange(1990, Number(AppVariables.ApplicationYear) + 1).map((item) => ({ value: item , text: item })) }
                                       title="Year"/>

                        </Col>

                    </Row>

                    <Row>

                        <Col md={6}>
                            <FormInput name="registration_number"
                                       title="Registration Number"
                                       type="text"
                                       required
                                       disabled={disableInputs}
                                       placeholder="Enter license plate no."/>
                        </Col>

                        <Col md={6}>
                            <FormInput name="chassis"
                                       title="Chassis"
                                       type="text"
                                       required
                                       disabled={disableInputs}
                                       placeholder="Enter tractor chassis number"/>
                        </Col>
                    </Row>

                    <ExpanderView isExpanded={true}
                                  alignContent={false}
                                  title={<span>Assignment Conditions</span>}>


                        <AssignmentRulesConfigDialog ref={r => this._assignmentConfigDlg = r}
                                                     fetchAssignmentRules={tractor => (values.assignment_rules || [])}
                                                     updateAssignmentRules={(tractor,rules) => {
                                                         setFieldValue('assignment_rules',rules);
                                                         return true;
                                                     }}/>

                        <AssignmentRuleInfo rules={values.assignment_rules || []}
                                            onEdit={() => this._assignmentConfigDlg.show(null)}/>

                    </ExpanderView>

                    <hr/>


                    <div className="clearfix">

                        <div className="pull-left">
                            <Label for={"operator"}><i className="fa fa-user"/> Operator</Label>
                        </div>

                        <div className="pull-right">
                            <Field name="registerNewOperator">
                                {({ field , form: { setFieldValue }}) =>{
                                    return <label><input type="checkbox" checked={field.value} onChange={evt => setFieldValue("registerNewOperator",evt.target.checked)}/> Register New Operator</label>
                                }}
                            </Field>
                        </div>

                    </div>

                    <FormInput name="operator"
                               type="dropdown"
                               icon="fa fa-user"
                               autoFocus={false}
                               dropdownItemRender={(props) => {

                                   const instance = props.data.instance;
                                   if(!instance)
                                       return;

                                   const { name , media  , phone } =  instance;
                                   return <TwoLineItemRender line1Value={name}
                                                             line2Prefix={"Phone"}
                                                             line2Value={phone}
                                                             media={media}/>;
                               }}
                               disabled={values.registerNewOperator || disableInputs}
                               placeholder={"Select tractor operator..."}
                               items={this.state.operators || operators}>
                        {this.state.isFetchingOperators && <MDProgress show overaly={false}/>}
                    </FormInput>

                </Col>

            </Row>

            <hr/>


        </div>
    }
}

export class OperatorRegistrationForm extends  React.Component{

    static propTypes = {
        header: PropTypes.any,
        disableInputs: PropTypes.bool,
        includeOwner: PropTypes.bool,
        includeTractor: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = OperatorRegistrationForm.getInitialState();
        this.proxy = TTLAsyncProxy.getInstance();
    }

    static getInitialState(){

        return {
            isFetchingTractors: false,
            tractors: null
        };

    }

    /**
     * Fetch tractors for selected tractor owner
     * @returns {Promise<Array>}
     */
    async fetchOwnerTractors( ownerId, idleOnly , exclude , include){

        let tractors;
        this.setState({ isFetchingTractors: true });

        try {

            //  get tractors
            tractors = await OperatorUtils.fetchOwnerTractors(ownerId, idleOnly, exclude, include);

        }
        catch (e) {
            tractors = [];
        }
        finally {
            this.setState({ isFetchingTractors: false });
        }

        return tractors;
    }

    render(){

        const { values,  setFieldValue , isValid , header , includeOwner , includeTractor , disableInputs } = this.props;
        const proxy = this.proxy;

        return <div>
            <Row>

                <Col md={4}>

                    <ImageUploadComponent name={Utils.formatAvatarName(values.name || "OPERATOR")}
                                          size={84}
                                          disabled={disableInputs}
                                          onChange={file => {
                                              setFieldValue('imageFile',file);
                                          }}/>

                    {values.name && <React.Fragment>
                        <hr/>

                        <div className="text-center">
                            <b>{values.name}</b>
                        </div>

                    </React.Fragment>}

                </Col>

                <Col md={8}>

                    {header}
                {includeOwner &&  <React.Fragment>

                    <FormInput name="owner"
                               title="Tractor Owner"
                               type="dropdown"
                               autoFocus={false}
                               disabled={disableInputs}
                               async
                               defaultOptions
                               onChange={async selected => {

                                   if(selected){

                                       const tractorOwnerId = selected.value;
                                       const tractors = this.fetchOwnerTractors(tractorOwnerId,true,undefined,undefined );

                                       this.setState({
                                           tractors: Utils.insertNone(_.clone(tractors))
                                       },() => {

                                           if(tractors.length > 0){
                                               const _first = tractors[0];
                                               setFieldValue('tractor',{ value: _first.id , label : _first.name });
                                           }
                                           else{
                                               setFieldValue('tractor',EmptyOption);
                                           }

                                       });

                                   }

                               }}
                               dropdownItemRender={(props) => {

                                   const { name , media  , user } =  props.data.instance;
                                   return <TwoLineItemRender line1Value={name}
                                                             line2Prefix={"Phone"}
                                                             line2Value={user.phone}
                                                             media={media}/>;
                               }}
                               loadOptions={async (value) => {

                                   const response = await proxy.processRequest( TractorOwnerEndpoints.getUrl(),{
                                       fields: [ 'id' , 'name' ],
                                       include: [ 'user' , 'media' ],
                                       search: { keyword: value , method: "inside" , fields: [ "name" , "user.phone" , "user.email" ] },
                                       pagination: {
                                           limit: 5,
                                           offset: 0
                                       },
                                       method: 'get'
                                   });

                                   return response.getPayload().map(v => ({ label: v.name , value: v.id , instance: v }));
                               }}
                               icon="fa fa-user"
                               placeholder="Select tractor owner..."
                               required/>

                               <hr/>

                </React.Fragment>}

                    <FormInput name="name"
                               title="Name"
                               icon="fa fa-user"
                               type="text"
                               disabled={disableInputs}
                               required
                               placeholder="Enter operator name"/>

                    <FormInput name="phone"
                               title="Phone"
                               icon="fa fa-phone"
                               type="phone"
                               disabled={disableInputs}
                               required
                               placeholder="Enter phone number"/>

                    <FormInput name="license"
                               title="License Class(es)"
                               type="dropdown"
                               multi
                               simple
                               required
                               disabled={disableInputs}
                               items={LicenseClasses.map(c => ({ text: c , value: c }))}
                               placeholder="Enter operator name"/>

                    <FormInput name="address"
                               icon="fa fa-map-marker"
                               title="Address"
                               type="location"
                               disabled={disableInputs}
                               required
                               placeholder="Enter operator address here"/>

                    <FormInput name="sex"
                               title="Gender"
                               icon="fa fa-user"
                               type="select"
                               disabled={disableInputs}
                               items={[
                                   { value: Gender.Male , text: "Male" },
                                   { value: Gender.Female , text: "Female" }
                               ]}
                               required/>

                    <hr/>

                    <FormInput name="email"
                               title="Email"
                               icon="fa fa-envelope"
                               type="email"
                               disabled={disableInputs}
                               required
                               placeholder="Enter operator email here"/>


                    {includeTractor && <React.Fragment>

                       <div className="clearfix">

                           <div className="pull-left">
                               <Label for={"tractor"}>{HTML.renderIcon('tractor_black')} Tractor</Label>
                           </div>

                           <div className="pull-right">
                               <Field name="registerNewTractor">
                                   {({ field , form: { setFieldValue }}) =>{
                                       return <label><input type="checkbox" checked={field.value} onChange={evt => setFieldValue("registerNewTractor",evt.target.checked)}/> Register New Tractor</label>
                                   }}
                               </Field>
                           </div>

                       </div>

                    </React.Fragment>}

                </Col>

            </Row>

            <hr/>
        </div>
    }

}


class CreateTractorDialog extends Component{

    static propTypes = {
        onExit: PropTypes.func,
        includeOwner: PropTypes.bool
    };

    static tractorInitialValues = {
        name: '' ,
        tractor_model: '',
        registration_number: '' ,
        chassis: '' ,
        year: new Date().getFullYear(),
        state: TractorState.Active,
        operator: EmptyOption,
        owner: null,
        registerNewOperator: false,
    };

    constructor(props){
        super(props);
        this.state = CreateTractorDialog.getInitialState();
        this.proxy = TTLAsyncProxy.getInstance();
        this._operations = [
            {
                key: "register-tractor",
                run: async (values,state) => {

                    const { imageFile : tractorMedia , assignment_rules , ...tractor } = values.tractor;

                    if(values.operator) {

                        if(typeof values.operator === "object"){
                            const { imageFile: operatorMedia, ...operator } = values.operator;
                            tractor.operator = operator;
                        }
                        else{
                            tractor.operator_id = values.operator;
                        }

                    }

                    if(assignment_rules){
                        tractor.assignment_rules = assignment_rules.map(({ service, ...rule }) => (rule));
                    }

                    const owner = values.owner;
                    const response = await this.proxy.processRequest(TractorsEndpoints.create(owner,tractor));
                    if(response.ok){
                        const _tractor = response.getPayload();
                        state['tractor'] = _tractor;

                        if(!_.isNil(tractor.operator) || !_.isNil(tractor.operator_id))
                            state['operator'] = (await this.proxy.processRequest(TractorsEndpoints.getAssignedOperator(_tractor.id))).getPayload();

                        return  true;
                    }

                    return false;
                }
            },
            {
                key: "upload-tractor-image",
                run: async (values,{ tractor }) => {

                    if(values.tractor && values.tractor.imageFile){
                        const { imageFile }  = values.tractor;
                        return await this.uploadProfileImage(imageFile,'tractor', tractor.id);
                    }

                    return true;
                }
            },
            {
                key: "upload-operator-image",
                run: async (values,{ operator }) => {

                    if(operator && values.operator.imageFile){

                        const { imageFile }  = values.operator;
                        return await this.uploadProfileImage(imageFile,'operator', operator.id);
                    }

                    return true;
                }
            }
        ];

        this.TractorValidationSchema = Yup.object().shape({
            name: Yup.string().required().label("Name"),
            tractor_model: Yup.string().required().label("Tractor Model"),
            registration_number: Yup.string().required('Enter registration number').label("Registration Number"),
            chassis: Yup.string().required('Enter chassis no.').label("Chassis"),
            year: Yup.number().required().label("Year"),
            state: Yup.number().required(),
            registerNewOperator: Yup.bool().notRequired(),
            operator: Yup.mixed().label("Operator"),
            owner: Yup.mixed().required('Please select a tractor owner').label("Tractor Owner"),
            assignment_rules: Yup.array().notRequired().label("AssignmentRules"),
            imageFile: Yup.mixed().notRequired()
        });

        this.OperatorValidationSchema = Yup.object().shape({
            name: Yup.string().required("Enter a valid name").label("Name"),
            phone: Yup.string().required().label("Phone Number").test(value => Utils.validatePhoneNumber(value,this._operatorRegistration.getFormikContext().values['phone-region'])),
            license: Yup.string(),
            address: Yup.mixed().required("Enter operator's address"),
            sex: Yup.number().required(),
            owner: Yup.mixed(),
            imageFile: Yup.mixed().notRequired()
        });


        //  handle registration
        this._handleRegistration = this._handleRegistration.bind(this);
    }

    static getInitialState(values){

        return {
            registerPhase: 0,
            registerState: {},
            errorMessage: null,
            registrationComplete: false,
            initialValues: values,
            allowInputEdit: true   //  allow input editing
        };

    }

    /**
     * Show Create Tractor Dialog
     */
    show(values){
        this.setState(CreateTractorDialog.getInitialState(values), () => this._dlg.show());
    }

    uploadProfileImage(file,entityName , entityId){

        return new Promise((resolve,reject) => {

            fileReaderStream(file).pipe(concat(async (content) => {

                try {

                    content = await MediaHelper.compressImageUploadAsync(content);

                    const response = await this.proxy.processRequest(MediaEndpoints.createMedia(entityName, entityId, file, content, AppVariables.ProfileImageTag));
                    if(response.ok){
                       return resolve(true);
                    }

                }
                catch (e) {
                    return reject(false);
                }
            }))

        });


    }


    async _handleRegistration(values){

        const { registerPhase , registerState }  = this.state;

        this.setState({  errorMessage : null });

        const results = await runStepAsync(registerPhase, registerState, values, this._operations);

        if (results.isComplete) {

            //  toast success
            HTML.toastSuccess('Tractor registered successfully!');

            this.setState({
                registerState: results.state,
                registerPhase: results.step,
                registrationComplete: true,
                errorMessage: null
            });

        }
        else{

            const state = results.error ? Utils.exceptionToFormErrors(results.error) : null;

            this.setState({
                registerState: results.state,
                registerPhase: results.step,
                errorMessage: _.isNil(results.error) ? null : (state ? state.statusMessage : null),
                allowInputEdit: results.step < 1 || _.isNil(results.error)
            }, () => {

                if(state){

                    if(this._tractorRegistration){
                        const _context = this._tractorRegistration.getFormikContext();
                        _context.setErrors(_.pick(state.errors,Object.keys(_context.values)) );
                    }

                    if(this._operatorRegistration){
                        const _context = this._operatorRegistration.getFormikContext();
                        _context.setErrors(_.pick(state.errors,Object.keys(_context.values)) );
                    }

                }


            });

        }
    }

    reset(){

        //  clear register values
        this._registerValues = null;

        //  reset state and wizard
        this.setState(CreateTractorDialog.getInitialState(), () => {
            this._wizard.reset();
        });

    }

    renderCompleteView(){

        const { registerState } = this.state;
        const { tractor , operator } = registerState;

        return <div className="p-lg-5">

            <div className="text-center">
                <h4>Tractor Registered Successfully <i className="fa fa-check-circle-o"/></h4>
            </div>

            <ExpanderView title="Tractor Info" isExpanded>

                <SectionedList items={[
                    {
                        title: "Name",
                        value: tractor.name
                    },
                    {
                        title: "Registration Number",
                        value: tractor.registration_number
                    },
                    {
                        title: "Model",
                        value: tractor.tractor_model
                    },
                    {
                        title: "Chassis",
                        value: tractor.chassis
                    },
                    {
                        title: "Year",
                        value: tractor.year
                    }
                ]}/>

            </ExpanderView>

            {operator && <ExpanderView title="Operator Info" isExpanded>

                <SectionedList items={[
                    {
                        title: "Name",
                        value: operator.name
                    },
                    {
                        title: "Phone",
                        value: operator.phone
                    },
                    {
                        title: "License Class(es)",
                        value: operator.license.replace(/,/g, ', ')
                    },
                    {
                        title: "Email",
                        value: <StandardValue value={operator.email}/>
                    }
                ]}/>
            </ExpanderView>}

            <hr/>

            <div className="text-center">
                <ButtonGroup>
                    <Button onClick={() => this.reset()} color="success" outline><i className="fa fa-plus"/> Register new tractor</Button>
                    <Button onClick={() =>  {

                        this._registerValues = null;
                        this._dlg.hide();

                    } }><i className="fa fa-close"/> Close</Button>

                </ButtonGroup>
            </div>

        </div>
    }

    async _validateTractorForm({ owner , assignment_rules , ...tractor }){

        this.setState({
             errorMessage: null
        });

        try{

            const response = await this.proxy.processRequest({
                ...TractorsEndpoints.create(owner.value,{
                    ...tractor,
                    assignment_rules: assignment_rules ? assignment_rules.map(({ service, ...rule }) => (rule)) : null
                }),
                verify: true
            });

            if(response.ok){

                const body = response.body;
                if(body.verify_status === VerifyStatus.Passed){
                    return true;
                }

                let errors = { };
                body.fields.forEach(err => {
                    errors[err.field] = err.message;
                });

                this._tractorRegistration.getFormikContext().setErrors(errors);
            }

        }
        catch (e) {

            this.setState({
                errorMessage: Utils.getResponseError(e)
            });

        }

        return false;
    }

    _getTractorFormInitialValues(){

        const { initialValues } = this.state;
        const _values = _.clone(CreateTractorDialog.tractorInitialValues);
        if(initialValues){

            if(initialValues.owner){
                _values['owner'] = { value: initialValues.owner.id , label: initialValues.owner.name };
            }

            if(initialValues.operator){
                _values['operator'] = { value: initialValues.operator.id , label: initialValues.operator.name };
            }

        }

        return _values;
    }

    render(){

        const { registrationComplete } = this.state;
        const { includeOwner } = this.props;

        return <SmartDialog title={"Tractor Registration"} large={true} ref={r => this._dlg = r} onExit={() => {
            const { registerState } = this.state;
            if(registerState.tractor){

                if(this.props.onExit)
                    this.props.onExit(registerState.tractor);

            }
        }}>

            {registrationComplete ? this.renderCompleteView() : <ReactWizard ref={r => this._wizard = r}>

                {({ getValue , setValue , next, prev , step }) => {

                    return <React.Fragment>

                        <WizardPhase name={"tractor-registration"}>

                            <Formik initialValues={this._getTractorFormInitialValues()}
                                    ref={r => this._tractorRegistration = r}
                                    enableReinitialize
                                    validationSchema={this.TractorValidationSchema}
                                    onSubmit={async ({ registerNewOperator , owner , operator , ...values },{ setSubmitting }) => {

                                        const { allowInputEdit } = this.state;
                                        const registerValues = this._registerValues;
                                        if(registerValues && !allowInputEdit){
                                            await this._handleRegistration(registerValues);
                                        }
                                        else {

                                            if (registerNewOperator) {

                                                //  validate
                                                if(!await this._validateTractorForm({ owner , ...values })){
                                                    return setSubmitting(false);
                                                }

                                                setSubmitting(false);

                                                //  persist tractor info within wizard context
                                                setValue('tractor',{
                                                    ...values,
                                                    owner
                                                });

                                                //advance to next phase
                                                return next();
                                            }



                                            const _values = {
                                                owner: owner.value,
                                                operator: operator.value,
                                                tractor: values
                                            };

                                            //  keep reference in component
                                            this._registerValues = _values;

                                            //
                                            await this._handleRegistration(_values);

                                        }

                                        setSubmitting(false);
                                    }}>
                                {(props) => {

                                    return <Form>

                                        <TractorRegistrationForm
                                            includeOwner={includeOwner}
                                            header={<div className="clearfix mb-2">
                                                <div className="pull-left">
                                                    <b>Tractor Registration Phase</b>
                                                </div>
                                                <div className="pull-right">
                                                    <b>Step 1 of {props.values.registerNewOperator ? 2 : 1}</b>
                                                </div>
                                            </div>}
                                            disableInputs={!this.state.allowInputEdit}
                                            {...props}/>

                                        {this.state.errorMessage && <p className="error-label" style={{padding: '10px'}}><i className="fa fa-exclamation-triangle"/> {this.state.errorMessage}</p>}

                                        <div className={"clearfix"}>

                                            <div className="pull-left">
                                                {props.isSubmitting && <MDSpinner size={32}/>}
                                            </div>

                                            <div className="pull-right">
                                                {props.values.registerNewOperator ? <Button color="green" disabled={props.isSubmitting || !props.isValid} title="Click to proceed to operator registration" >Proceed Registration <i className="icon-arrow-right"/></Button>:
                                                    <Button color="green" disabled={props.isSubmitting || !props.isValid} title="Complete Tractor Registration">Register Tractor <i className="fa fa-check"/></Button>}
                                            </div>

                                        </div>

                                    </Form>
                                }}
                            </Formik>

                        </WizardPhase>

                        <WizardPhase name={"operator-registration"}>

                            <Formik initialValues={{
                                        name: '',
                                        phone:'',
                                        license: '',
                                        address: null,
                                        sex: Gender.Male,
                                        email: '',
                                        owner: null
                                    }}
                                    validationSchema={this.OperatorValidationSchema}
                                    ref={r => this._operatorRegistration = r}
                                    onSubmit={async ({ address, owner: operatorOwner, sex , ...values },{ setSubmitting }) => {

                                        const { allowInputEdit } = this.state;
                                        const registerValues = this._registerValues;
                                        if(registerValues && !allowInputEdit){
                                            await this._handleRegistration(registerValues);
                                        }
                                        else {

                                            const { owner , ...tractor } = getValue('tractor');

                                            const operatorPayload = {
                                                ...values,
                                                sex: Number(sex),
                                                address: address ? address.text : null,
                                                address_lat: address ? address.lat : null,
                                                address_long: address ? address.lng : null,
                                                phone: Utils.fixPhone(values.phone,values['phone-region'])
                                            };

                                            delete operatorPayload['phone-region'];

                                            const _values = {
                                                owner: owner.value,
                                                operator: operatorPayload,
                                                tractor
                                            };

                                            //  keep reference in component
                                            this._registerValues = _values;

                                            //
                                            await this._handleRegistration(_values);

                                        }

                                        setSubmitting(false);
                                    }}>

                                {(props) => (<Form>

                                    <OperatorRegistrationForm
                                        header={<div className="clearfix mb-2">
                                            <div className="pull-left">
                                                <b>Operator Registration Phase</b>
                                            </div>
                                            <div className="pull-right">
                                                <b>Step 2 of 2</b>
                                            </div>
                                        </div>}
                                        disableInputs={!this.state.allowInputEdit}
                                        {...props}/>

                                    {this.state.errorMessage && <p className="error-label" style={{padding: '10px'}}><i className="fa fa-exclamation-triangle"/> {this.state.errorMessage}</p>}

                                    <Row>

                                        <Col md={4}>
                                            {props.isSubmitting && <MDSpinner size={32}/>}
                                        </Col>

                                        <Col md={8}>

                                            <div className={"clearfix"}>

                                                <div className="pull-left">
                                                    <Button onClick={prev}><i className="icon-arrow-left"/> Back</Button>
                                                </div>

                                                <div className="pull-right">
                                                    <Button color="green" disabled={props.isSubmitting || !props.isValid} title="Register tractor with new operator">Register Tractor<i className="fa fa-check"/></Button>
                                                </div>

                                            </div>

                                        </Col>

                                    </Row>

                                </Form>)}

                            </Formik>

                        </WizardPhase>

                    </React.Fragment>

                }}
            </ReactWizard>}

        </SmartDialog>

    }
}

export default CreateTractorDialog;


// WEBPACK FOOTER //
// ./src/components/CreateTractorDialog/CreateTractorDialog.js